const listaDeBacklogMacroprocessos = (state) => {
    return state.macroprocessos;
}

const loadingBacklog = (state) => {
    return state.loading
}

const listaTarefasBacklog = (state) => {
    return state.items
}

const listaTarefas = (state) => {
    return state.tarefas
}

const listaTarefasBacklogInterrupcoes = (state) => {
    return state.interrupcoes;
}

const listaTarefasBacklogBoxPainelAlarmes = (state) => {
    return state.painelAlarmes.box;
}

const listaDeBacklogDesativacaoMacroprocessos = (state) => {
    return state.itemsMacroprocessoDesativacao
}

const listaTarefasBacklogDesativacao = (state) => {
    return state.itemsDesativacao
}

const headerBacklog = (state) => {
    return state.headerBacklog
}

const detalhesProcessoBacklog = (state) => {
    return state.detalhesProcessoBacklog
}

const loadingDetalhesProcessoBacklog = (state) => {
    return state.loadingDetalhesProcesso
}

const filtrosPainelBacklog = (state) => {
    return state.filtrosPainelBacklog
}


export {
    listaDeBacklogMacroprocessos,
    headerBacklog,
    detalhesProcessoBacklog,
    loadingDetalhesProcessoBacklog,
    loadingBacklog,
    listaTarefasBacklog,
    listaTarefasBacklogInterrupcoes,
    listaTarefas,
    listaTarefasBacklogBoxPainelAlarmes,
    listaDeBacklogDesativacaoMacroprocessos,
    listaTarefasBacklogDesativacao,
    filtrosPainelBacklog,
}